import BaseEllipseContent from "./BaseEllipseContent.vue";

export * from "./BaseEllipseContent.vue";
export default BaseEllipseContent;
